import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable, of } from 'rxjs';
import { Router } from '@angular/router';

const API_LOGIN = environment.url_login;
const API = environment.url_server;

@Injectable()
export class AuthenticationService {

  constructor(
    private http: HttpClient,
    private router: Router,

  ) { }


    getToken(login, senha, tokenCaptcha): Observable<any> {
      const loginForm = {
        dominio: 'PORTAL',
        login: login,
        senha: senha,
        tokenCaptcha: tokenCaptcha,
      };

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type':  'application/json',
          }),
      };
      return this.http.post<any>(API_LOGIN + '/auth', loginForm, httpOptions);


  }

  isLoggedIn(): Observable<any> {
    var token = localStorage.getItem('bway-token');
    return this.http.get(API_LOGIN + '/auth/validateToken?token=' + token);

  }



  doLogout() {
    var token = String(localStorage.getItem('bway-token'));
    token = token.replace('"', '').replace('"', '');

    var headers = new Headers();
    headers.append('Content-Type', 'application/json');
    const customLogin = localStorage.getItem('bway-customLogin');
    localStorage.clear();
    localStorage.setItem('bway-customLogin', customLogin);

    /* localStorage.removeItem('bway-user');
     localStorage.removeItem('bway-product');
     localStorage.removeItem('bway-token');
     localStorage.removeItem('bway-logged-date');
     localStorage.removeItem('bway-domain');*/
    this.router.navigate(['/login']);
  }

  getRoles(): Observable<any> {
    return this.http.get(API + '/auth/accessRoles');

  }

  roleVerify(roles: any): Observable<any> {
    let params: HttpParams = new HttpParams();
    params = params.append('roles', roles);
    return this.http.get(API + '/auth/roleVerify', {params});

  }

}
